/* eslint-disable import/prefer-default-export */
export enum BillingStatusItemType {
  DEFAULT = 'DEFAULT',
  LOADING = 'LOADING',
  VALID = 'VALID',
  INVALID = 'INVALID',
}
